<template>
	<div>
		<div id="restaurant-cart"></div>
		<!-- HEADER -->
		<wrapper-mobile-view :z_index="1030">
			<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
				<div class="d-flex">
					<div class="lh-1 align-self-center mr-3">
						<router-link :to="`/${getMerchant().code}`">
							<svg class="lh-1 cursor-pointer" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_581_18)">
									<path
										d="M0.0294189 8.00744C0.0294189 8.27112 0.145437 8.5137 0.356381 8.7141L7.35969 15.7069C7.57064 15.9073 7.79213 16.0022 8.04526 16.0022C8.56207 16.0022 8.97341 15.6225 8.97341 15.0951C8.97341 14.842 8.87848 14.5889 8.70973 14.4306L6.34717 12.0259L2.1705 8.21839L1.949 8.7352L5.34519 8.94614H18.6874C19.2358 8.94614 19.6155 8.5559 19.6155 8.00744C19.6155 7.45899 19.2358 7.06874 18.6874 7.06874H5.34519L1.949 7.27969L2.1705 7.80705L6.34717 3.98898L8.70973 1.58422C8.87848 1.41546 8.97341 1.17288 8.97341 0.919749C8.97341 0.392393 8.56207 0.0126953 8.04526 0.0126953C7.79213 0.0126953 7.57064 0.0970726 7.3386 0.32911L0.356381 7.30079C0.145437 7.50118 0.0294189 7.74376 0.0294189 8.00744Z"
										fill="black" fill-opacity="0.85" />
								</g>
								<defs>
									<clipPath id="clip0_581_18">
										<rect width="19.5861" height="16" fill="white" transform="translate(0.0294189 0.0126953)" />
									</clipPath>
								</defs>
							</svg>
						</router-link>
					</div>
					<div class="lh-1 align-self-center">
						<p class="mb-0 body-1-2">Checkout</p>
					</div>
				</div>
			</div>
		</wrapper-mobile-view>
		<block :height="62" />

		<div v-if="is_load" class="w-100 my-4 text-center">
			<loader />
		</div>
		<template v-else>
			<div class="p-4" v-if="error != ''">
				<ErrorMessage :message="error" />
			</div>
			<template v-else>
				<template v-if="payment_method.custom_popup == ''">
          <span id="top-section"></span>
          <!-- SERVE OPTION -->
					<div v-if="getMerchant().use_delivery && getMerchant().payment_mode != 'PAY_LATER'">
						<div class="px-4 w-100">
							<p class="mb-0 body-1-4">Choose Your Dining Preference</p>
							<p class="mb-3 body-3-3-1">Indicate whether you prefer delivery or on-site dining.</p>
							<div class="w-100">
								<div 
                  class="w-100 mb-3 radius-6 cursor-pointer position-relative" 
                  v-for="(serve,serve_i) in serve_option.list" 
                  :id="serve.id" @click="serveOptionSelect(serve)" 
                  :class="{
                    'border-form': serve.id != serve_option.selected.id,
                    'border-green': serve.id === serve_option.selected.id
                  }">
									<div 
                    class="d-flex align-items-center justify-content-between z-index-1026" 
                    :class="{
                      'cursor-disable': serve.id === 'delivery' && !getRestaurantDeliveryAvb(),
                      'py-3' : serve.id === serve_option.selected.id || !serve_option.selected.id,
                      'py-1' : serve.id !== serve_option.selected.id
                    }">
                    <div class="d-flex align-items-center">
                      <div class="px-3 text-center" :class="{'opacity-06': serve.id === 'delivery' && !getRestaurantDeliveryAvb()}">
                        <svg v-if="serve.id != serve_option.selected.id" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z"
                            fill="#222222" />
                        </svg>
                        <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" class="fill-primary"/>
                        </svg>
                      </div>
                      <div>
                        <div class="w-100 pr-3" :class="{'opacity-06': serve.id === 'delivery' && !getRestaurantDeliveryAvb()}">
                          <p class="mb-0 body-2-1">{{ serve.title }}</p>
                          <p class="mb-0 body-3-3-1">{{ serve.subtitle }}</p>
                        </div>
                        <p v-if="serve.id === 'delivery' && !getRestaurantDeliveryAvb()" class="mb-0 body-3-3-2 text-danger">There are products that do not support delivery</p>
                      </div>
                    </div>
                    <div class="pr-3" v-if="serve.id === serve_option.selected.id || !serve_option.selected.id">
                      <img v-if="serve.id === 'dine_in'" src="../../assets/img/icon/cutlery.png" width="40">
                      <img v-else src="../../assets/img/icon/fast-delivery.png" width="40">
                    </div>
									</div>
									<div class="primary-overlay z-index-1025 radius-6" v-if="serve.id == serve_option.selected.id"></div>
								</div>
							</div>

              <!-- DELIVERY DETAIL -->
              <div v-if="serve_option.selected.id === 'delivery'" class="w-100 pt-4 mt-4 border-t-form-2-dashed">
                <DeliveryDetail />
                <p class="mb-0 mt-2 body-2 text-danger" v-if="serve_option.error != ''">{{ serve_option.error }}</p>
              </div>
						</div>
						<div class="w-100 my-4" id="middle_section" style="height: 8px;background-color: #EEE;"></div>
					</div>
          
					<!-- PRODUCT LIST -->
					<div class="px-4">
						<p class="mb-4 body-1-4">Order Summary</p>
						<div class="w-100 mb-5">
							<div class="w-100" v-for="(product_cart,product_cart_i) in getRestaurantOrder().cart">
								<MenuCart :data="product_cart" :product_index="product_cart_i" use_image></MenuCart>
							</div>
						</div>
						<div class="w-100 border-orange p-3 radius-6" id="add_menu_section">
							<div class="row no-gutters">
								<div class="col-9 align-self-center">
									<div class="pr-3">
										<p class="mb-0 body-2-1">Add more to your order?</p>
										<p class="mb-0 body-3-3-1">Discover diverse and delicious options</p>
									</div>
								</div>
								<div class="col-3 align-self-center">
									<button class="g-btn g-btn-secondary g-btn-sm w-100" @click="$router.push(`/${getMerchant().code}/`)">Add More</button>
								</div>
							</div>
						</div>
					</div>
					<div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

					<!-- GUEST INFO -->
					<div class="px-4">
						<p class="mb-0 body-1-4">Personalize Your Order, Note by Note!</p>
						<p class="mb-3 body-3-3-1">Add your name, table number, and special requests for a perfect meal!</p>
            
            <!-- LOGIN/REGISTER -->
            <div class="p-3 border-semi-grey rounded-6 position-relative mb-4" v-if="!isLoggedIn()">
              <div class="w-100 z-index-1026 position-relative">
                <div class="d-flex align-items-center mb-3">
                  <div class="mr-3 flex-0">
                    <svg width="30" height="28.8" viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M20.7197 23.4622C26.0828 23.4622 30.6089 18.7115 30.6089 12.57C30.6089 6.5416 26.0494 1.95416 20.7197 1.95416C15.39 1.95416 10.8305 6.62643 10.8349 12.6146C10.8394 18.7115 15.3812 23.4622 20.7197 23.4622ZM4.40358 46.2676H36.5789C36.3024 45.675 36.1641 45.042 36.1641 44.3688V35.3786C34.8003 34.2997 33.7874 32.8695 33.1942 31.2659C29.9529 29.2092 25.7191 27.8148 20.7197 27.8148C8.00167 27.8148 0 36.4888 0 42.7956C0 44.9625 1.64828 46.2676 4.40358 46.2676Z"
                        class="fill-primary" />
                      <path
                        d="M42.4595 18.5428C38.2325 18.5428 34.8879 21.9119 34.8879 26.07C34.8879 29.2144 36.74 31.9443 39.573 33.1029V44.3688C39.573 44.7026 39.7332 44.965 39.9646 45.2233L41.9566 47.2001C42.2302 47.4603 42.6615 47.4894 42.9929 47.1825L46.6416 43.5137C46.9774 43.1936 46.9642 42.7602 46.6326 42.4445L44.5138 40.2877L47.5221 37.3598C47.8133 37.0485 47.7976 36.6019 47.4819 36.2461L44.5868 33.3466C48.0446 31.8738 49.9998 29.2527 49.9998 26.07C49.9998 21.9119 46.6308 18.5428 42.4595 18.5428ZM42.4394 22.2234C43.6853 22.2234 44.7149 23.2685 44.7149 24.4987C44.7149 25.8048 43.6853 26.8342 42.4394 26.8342C41.1824 26.8342 40.1284 25.8048 40.1284 24.4987C40.1284 23.2685 41.1579 22.2234 42.4394 22.2234Z"
                        class="fill-primary" />
                    </svg>
                  </div>
                  <div class="w-100">
                    <p class="mb-1 body-2-4">Unlock More Benefits with an Account</p>
                    <p class="mb-0 body-3-3">Enjoy Faster Transactions and Easy Order History Access</p>
                  </div>
                </div>
                <div class="w-100">
                  <div class="row slim-grid-row">
                    <div class="col-6">
                      <button class="g-btn g-btn-primary g-btn-md w-100"
                        @click="goToAuthPage('Login')">Login</button>
                    </div>
                    <div class="col-6">
                      <button class="g-btn g-btn-secondary g-btn-md w-100"
                        @click="goToAuthPage('Register')">Register</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="z-index-1025 position-absolute w-100 h-100 bg-green radius-12"
                style="top:0;left:0;opacity:0.02"></div>
            </div>

						<GuestFormV2 v-if="show_guest_form" ref="order_guest_form" :directRequired="guestFormRequiredFIeld" type="ORDER"  />
					</div>
					<div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

          <!-- BITESHIP : COURIER SELECTION -->
          <template v-if="getMerchant().use_biteship && getRestaurantDelivery().isActive">
            <div class="px-4 position-relative">
              <span id="courier-section" class="position-absolute" style="top: -100px"></span>
              <p class="mb-0 body-1-4">Courier Options</p>
              <p class="mb-3 body-3-3-1">Choose delivery partner</p>
              <CourierSelection />
              <p class="mb-0 mt-2 body-2 text-danger" v-if="courierRequiredError != ''">{{ courierRequiredError }}</p>
            </div>
            <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
          </template>
          
					<!-- PROMO CODE -->
					<div class="px-4" id="promo_section">
						<p class="mb-0 body-1-4">Apply Promo Code</p>
						<p class="mb-3 body-3-3-1">Enter your code to unlock special offers.</p>
						<PromoCodeCart></PromoCodeCart>
					</div>
					<div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

					<!-- PRICE DETAIL -->
					<div class="px-4">
						<p class="mb-0 body-1-4">Price Details</p>
						<p class="mb-3 body-3-3-1">Review the cost breakdown before finalizing.</p>
						<div class="w-100">
							<div class="row slim-grid-row mb-2">
								<div class="col-7 align-self-center">
									<p class="mb-0 body-2-1">Subtotal</p>
								</div>
								<div class="col-5 text-right align-self-center">
									<p class="mb-0 font-lato text-14">{{ $formatCurrency(getRestaurantOrderSubTotal()) }}</p>
								</div>
							</div>
							<div class="row slim-grid-row mb-2">
								<div class="col-6">
									<p class="mb-0 body-2-1">Discount</p>
								</div>
								<div class="col-6 text-right">
									<p class="mb-0 font-lato text-14" :class="{'text-green': getRestaurantOrderTotalPromo() > 0}">- {{ getRestaurantOrderTotalPromo() > 0 ? $formatCurrency(getRestaurantOrderTotalPromo()) : '' }}</p>
								</div>
							</div>
							<div class="row slim-grid-row mb-2">
								<div class="col-7 align-self-center">
									<p class="mb-0 body-2-1">Taxes & Services</p>
								</div>
								<div class="col-5 text-right align-self-center">
									<p class="mb-0 font-lato text-14">{{ $formatCurrency(getRestaurantOrderTotalTaxServices()) }}</p>
								</div>
							</div>
              <template v-if="getRestaurantDelivery().isActive && serve_option.selected.id == 'delivery'">
                <div class="row slim-grid-row mb-2">
                  <div class="col-7 align-self-center">
                    <p class="mb-0 body-2-1">Delivery Fee</p>
                  </div>
                  <div class="col-5 text-right align-self-center">
                    <p class="mb-0 font-lato text-14">{{ $formatCurrency(getRestaurantDeliveryFee()) }}</p>
                  </div>
                </div>
                <div class="row slim-grid-row mb-2" v-if="getRestaurantDelivery().detail.packaging_fee">
                  <div class="col-7 align-self-center">
                    <p class="mb-0 body-2-1">Packaging Fee</p>
                  </div>
                  <div class="col-5 text-right align-self-center">
                    <p class="mb-0 font-lato text-14">{{ $formatCurrency(getRestaurantDelivery().detail.packaging_fee) }}</p>
                  </div>
                </div>
              </template>
							<div class="row slim-grid-row mb-2" v-if="payment_surcharge > 0">
								<div class="col-7 align-self-center">
									<p class="mb-0 body-2-1">Payment Surcharge</p>
								</div>
								<div class="col-5 text-right align-self-center">
									<p class="mb-0 font-lato text-14">{{ $formatCurrency(payment_surcharge) }}</p>
								</div>
							</div>
							<div class="border-b-semi-grey-dashed-2 w-100 my-3"></div>
							<div class="row slim-grid-row" id="for-payment-section">
								<div class="col-6">
									<p class="mb-0 body-1-4">Total</p>
								</div>
								<div class="col-6 text-right">
									<p class="mb-0 font-lato text-16">{{ $formatCurrency(total_price) }}</p>
								</div>
							</div>
						</div>
					</div>
					<div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>

					<!-- PAYMENT TIME & METHODS -->
					<div class="px-4 w-100 mb-5" id="payment_section">
						<template v-if="!getRestaurantDelivery().isActive">
							<template v-if="getMerchant().payment_mode == 'PAY_LATER'">
								<p class="mb-0 body-1-4">Payment</p>
								<p class="mb-3 body-3-3-1">Enjoy your meal now, settle the bill later.</p>
							</template>
							<template v-if="getMerchant().payment_mode == 'PAY_IMMEDIATELY_OR_LATER'">
								<p class="mb-0 body-1-4">Payment Options</p>
								<p class="mb-3 body-3-3-1">Choose how you'd like to settle.</p>
								<div class="w-100">
									<div class="w-100 mb-3 radius-6 cursor-pointer position-relative" v-for="(p_mode,p_mode_i) in payment_mode.list" :id="p_mode.id" @click="selectPaymentMode(p_mode)" :class="p_mode.id != payment_mode.selected.id ? 'border-form' : 'border-green'">
										<div class="d-flex align-items-center py-3 z-index-1026">
											<div class="px-3">
												<svg v-if="p_mode.id != payment_mode.selected.id" width="20" height="20" viewBox="0 0 20 20" fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path fill-rule="evenodd" clip-rule="evenodd"
														d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z"
														fill="#222222" />
												</svg>
												<svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" class="fill-primary"/>
												</svg>
											</div>
											<div class="w-100 pr-3">
												<p class="mb-0 body-2-1">{{ p_mode.title }}</p>
												<p class="mb-0 body-3-3-1">{{ p_mode.description }}</p>
											</div>
										</div>
										<div class="primary-overlay z-index-1025 radius-6" v-if="p_mode.id == payment_mode.selected.id"></div>
									</div>
								</div> 
								<p class="mb-0 mt-2 body-2 text-danger" v-if="payment_mode.error">Please select payment option</p>
							</template>
						</template>
						<div class="w-100 mb-4" :class="{'mt-4 border-t-semi-grey-dashed-2' : !this.getRestaurantDelivery().isActive}" v-if="getMerchant().payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && payment_mode.selected.id == 'PAY_IMMEDIATELY'"></div>
						<div class="w-100" v-if="getMerchant().payment_mode == 'PAY_IMMEDIATELY' || (getMerchant().payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && payment_mode.selected.id == 'PAY_IMMEDIATELY')">
							<p class="mb-0 body-1-4">Payment Method</p>
							<p class="mb-3 body-3-3-1">Choose your preferred way to pay securely.</p>
							<div class="w-100">
								<PaymentMethod ref="payment_method" module="restaurant" @selectPayment="selectPayment" @doneLoad="paymentMethodDoneLoad"></PaymentMethod>
							</div>
						</div>
					</div>

					<!-- CONTACT DETAIL -->
					<template v-if="showGuestFormForPayment">
						<div id="payment_guest_form" class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
						<div class="px-4 pb-5">
							<p class="mb-0 body-1-4">Contact Detail</p>
							<p class="mb-3 body-3-3-1">Some payment methods require your contact information</p>
							<div class="w-100">
								<GuestFormV2 v-if="show_guest_form" ref="payment_guest_form" type="PAYMENT"  />
							</div>
						</div>
					</template>

					<block :height="100" />
					<wrapper-mobile-view fixed_position="bottom">
						<div class="w-100 px-4 pb-4 bg-white">
							<div class="row slim-grid-row mb-2"> 
								<div class="col-12 mb-2 text-center" v-if="error_push != ''">
									<p class="mb-0 body-2 text-danger">Error : {{ error_push }}</p>
								</div>
								<div class="col-6">
									<p class="mb-0 body-1-4">Total</p>
								</div>
								<div class="col-6 text-right">
									<p class="mb-0 font-lato text-16">{{ $formatCurrency(total_price) }}</p>
								</div>
							</div>
							<state-button variant="primary" size="xl" block :click="submitForm">Place Order</state-button>
						</div>
					</wrapper-mobile-view>
				</template>

				<!-- CC XENDIT POPUP -->
				<template v-if="payment_method.custom_popup == 'XENDIT'">
					<XenditInputCC
						:tx_payment="tx.payment"
						module_page="RESTAURANT"
						submodule_page="DEFAULT"
						@expired="closeXenditCC">
					</XenditInputCC>
				</template>
			</template>
		</template>

		<!-- PAY_LATER DONE -->
		<popup-detail 
			id_ref="success_trx"
			direction="bottom" 
			:show="show_result"
			use_max_size
			wrapper_size="mobile"
			use_footer
			no_close_backdrop
			@close="toggleResult">
			<template v-slot:body>
				<div class="py-5 px-4 text-center">
					<div class="rounded-100 my-2 w-20 mx-auto">
						<div class="bg-green rounded-100 mx-auto size-icon-in">
							<img src="../../assets/img/icon/correct-white.png" width="40" style="margin: 20px 20px">
						</div>
					</div>
					<p class="mb-0 body-2-2 text-18 text-green font-extrabold">{{$t('restaurant.order-success.title')}}</p>
					<p class="mb-2 body-2-2">{{$t('restaurant.order-success.desc')}}</p>
				</div>
			</template>
			<template v-slot:footer>
				<div class="px-3 pt-3">
					<router-link :to="`/${getMerchant().code}`">
						<button 
							class="ga-btn-primary-lg" >
							Order Again
						</button>
					</router-link>
				</div>
			</template>
		</popup-detail>

    <!-- EMPTY -->
    <popup-detail 
			id_ref="empty_cart"
			direction="bottom" 
			:show="showEmptyCart"
			use_max_size
			wrapper_size="mobile"
			no_close_backdrop
			@close="toggleEmptyCart">
      
      <template v-slot:body>
        <div class="p-5 text-center">
          <div class="w-100 text-center mb-5">
            <EmptyCartIcon :width="200" />
          </div>
          <p class="heading-4-1 mb-0">Empty!</p>
          <p class="body-2 mb-4">Your cart is empty, add some food or drink!</p>
          <button class="g-btn g-btn-primary g-btn-lg py-12px" type="button" @click="goToHome()">
            Pick Food
          </button>
        </div>
      </template>
      
    </popup-detail>
	</div>
</template>
<script>
	import { post, get } from "@/services/index.js";
	import {mapGetters,mapMutations} from 'vuex';
	import BlankPage from "@/components/general/BlankPage";
	import MenuCart from "@/components/restaurant-v2/menuCart"
	import PromoCodeCart from "@/components/restaurant-v2/promoCodeCart"
	import WarningBox from '@/components/general/WarningBox'
	import XenditInputCC from '@/components/hotel/be/XenditInputCC';
	import PaymentMethod from '@/components/general/payment/PaymentMethod';
	import GuestForm from "@/components/restaurant-v2/GuestForm";
  import GuestFormV2 from "@/components/restaurant-v2/GuestFormV2.vue";
	import Delivery from "@/components/general/Delivery";
  import EmptyCartIcon from "../../components/restaurant-v2/EmptyCartIcon.vue";
  import DeliveryForm from "../../components/general/DeliveryForm.vue";
  import DeliveryDetail from "../../components/general/DeliveryDetail.vue";
  import CourierSelection from "../../components/general/CourierSelection.vue";

	export default{
		components:{
			BlankPage,
			MenuCart,
			PromoCodeCart,
			WarningBox,
			XenditInputCC,
			PaymentMethod,
			Delivery,
			GuestForm,
      GuestFormV2,
      EmptyCartIcon,
      DeliveryForm,
      DeliveryDetail,
      CourierSelection
		},
		data(){
			return{
				is_load: false,
        note: '',
        error: '',
        error_push: '',
        show_result: false,
        show_guest_form: false,
				payment_mode: {
          list: [
						{
							id: 'PAY_LATER',
              title: 'Pay at Chasier',
              description: 'Enjoy your meal now, settle the bill later.'
            },
						{
							id: 'PAY_IMMEDIATELY',
							title: 'Instant Payment',
							description: 'Securely pay now for swift confirmation.'
						}
          ],
          selected: {},
					error: ''
        },
        payment_method:{
        	selected:{},
        	error: '',
        	custom_popup: ''
        },
        tx:{
        	inquiry: {},
        	payment: {}
        },
        serve_option:{
          list: [
            {id: 'dine_in',title: 'Dine In',subtitle: 'Savor the moment at our place.'},
            {id: 'delivery',title: 'Delivery',subtitle: 'Effortless dining, delivered to your door.'}
          ],
          selected: {},
					error: ''
        },
        showEmptyCart: false,
        courierRequiredError: ''
			}
		},
		computed:{
      sub_total_price(){
        return this.getRestaurantOrderSubTotal()+this.getRestaurantOrderTotalTaxServices()-this.getRestaurantOrderTotalPromo()
      },
      payment_surcharge(){
				let total = 0

				if(this.payment_method.selected.id){
					if(this.payment_method.selected.surcharge_type == 'PERCENT'){
						total = (this.sub_total_price/100)*this.payment_method.selected.surcharge_value
					}else{
						total = this.payment_method.selected.surcharge_value
					}
				}

				return total
			},
			delivery_fee(){
        return this.getRestaurantDeliveryFee();
      },
      packaging_fee(){
        let total = 0
        if(this.getMerchant().use_delivery && this.serve_option.selected.id == 'delivery'){
          total = this.getRestaurantDelivery().detail.packaging_fee ? this.getRestaurantDelivery().detail.packaging_fee : 0;
        }
        return total
      },
      total_price(){
      	return Math.round(this.sub_total_price+this.payment_surcharge)+this.delivery_fee+this.packaging_fee
      },
			need_payment(){
        let default_payment_now = this.getMerchant().payment_mode == 'PAY_IMMEDIATELY'
        let selected_paymnet_now = this.getMerchant().payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.selected.id == 'PAY_IMMEDIATELY' 

        return default_payment_now || selected_paymnet_now
      },
			need_guest_data_for_payment(){
        const { payment_mode } = this.getMerchant();
        const isPaymentImmediately = payment_mode === 'PAY_IMMEDIATELY';
        const isPaymentImmediatelySelected = payment_mode === 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.selected.id == 'PAY_IMMEDIATELY';
        
        if(!(isPaymentImmediately || isPaymentImmediatelySelected)) return false;

        
        const isPaymentMethodSelected = this.$isNotEmptyV2(this.payment_method.selected)
        if(!isPaymentMethodSelected) return false;

        const { bank_name, payment_method } = this.payment_method.selected
        const isPaymentNeedAuth = !(bank_name == 'DIRECT_PAYMENT' || (bank_name == 'WISE' && payment_method == 'BANK_TRANSFER'));
        return isPaymentNeedAuth;
			},
      showGuestFormForPayment(){
        if(!this.need_guest_data_for_payment) return false;
        
        const { order_form_phone_number, order_form_email } = this.getMerchant();
        const isFormNeedDisplayed = order_form_phone_number === 'HIDE' || order_form_email === 'HIDE'
        return isFormNeedDisplayed;
      },
			total_product_cart(){
        return this.getRestaurantOrder().cart.length
      },
      guestFormRequiredFIeld(){
        if(!this.need_guest_data_for_payment) return []; 

        const { order_form_phone_number, order_form_email } = this.getMerchant();
        let requiredField = []
        if(order_form_phone_number === 'SHOW') requiredField.push('phone_number'); 
        if(order_form_email === 'SHOW') requiredField.push('email'); 

        return requiredField;
      }
    },
		watch:{
      total_product_cart(){
        if(this.total_product_cart == 0){
          this.goToHome()
        }
      }
    },
    mounted(){
			setTimeout(() => {
        this.$smoothScroll('restaurant-cart')
      }, 300);
			this.setupDeliveryConfig()
      if(!this.isNotLogin()){
        this.getUserProfile()
      }else{
        this.show_guest_form = true
      }

      if(this.sub_total_price === 0) this.toggleEmptyCart()
    },
    destroyed(){
    	if(Object.keys(this.tx.inquiry).length > 0){
    		this.resetAllDataRestaurant()
    	}
    },
		methods:{
			...mapGetters([
				'isNotLogin',
				'getCurrentUser',
				'getMerchant',
				'getRestaurantOrder',
				'getRestaurantOrderTotal',
        'getRestaurantOrderTotalTaxServices',
        'getRestaurantOrderTotalPromo',
        'getRestaurantOrderSubTotal',
        'getRestaurantAuth',
				'getRestaurantDelivery',
				'getRestaurantCustomer',
        'getRestaurantDeliveryAvb',
        'isLoggedIn',
        'getRestaurantDeliveryFee'
			]),
			...mapMutations(['setRestaurantAuth','resetRestaurantOrder','setActiveRoute','setRestaurantDeliveryActive','resetAllDataRestaurant', 'setActiveRoute', 'setRestaurantCustomer']),

			// GENERAL
      toggleEmptyCart(){
        this.showEmptyCart = !this.showEmptyCart
        if(!this.showEmptyCart){
          this.goToHome();
        }
      },
      getUserProfile(){
        this.show_guest_form = false
        get("BASE","auth/profile").then(response=>{
          const { first_name, last_name, email, phone } = response.data.user
          const vuex_data = this.$deepCopy(this.getRestaurantCustomer())
          let params = []
          if(!this.$isNotEmpty(vuex_data.name)){
            let fullName = `${first_name} ${this.$isNotEmpty(last_name) ? last_name : ''}`
            params.push({
              key: 'name',
              value: fullName.trim()
            })
          }
          if(!this.$isNotEmpty(vuex_data.email)){
            params.push({
              key: 'email',
              value: email
            })
          }
          if(!this.$isNotEmpty(vuex_data.phone_number)){
            params.push({
              key: 'phone_number',
              value: phone
            })
          }
          if(params.length > 0){
            this.setRestaurantCustomer(params)
          }
          this.show_guest_form = true
        })
      },
      goToAuthPage(page) {
        this.setActiveRoute('cart')
        this.$router.push({
          name: page,
          params: {
            merchant_code: this.getMerchant().code
          }
        })
      },
			goToHome(){
	      this.$router.push({
	        path: "/" + this.getMerchant().code,
	      });
	    },
      toggleResult(){
				this.show_result = !this.show_result
			},
			goToPaymentResult(){
				this.$router.push({
          name: 'RestaurantTrxResult',
          params:{
          	merchant_code: this.getMerchant().code,
            trx_id : this.tx.inquiry.id
          }
        })
			},
			setupDeliveryConfig(){
        const isDeliveryNotAvb = !this.getMerchant().use_delivery;
        const isProductInvalid = !this.getRestaurantDeliveryAvb();
        if(isDeliveryNotAvb || isProductInvalid){
          this.setRestaurantDeliveryActive(false)
          this.serve_option.selected = this.serve_option.list[0];
        }else if(this.getRestaurantDelivery().isActive && this.getRestaurantDeliveryAvb()){
          this.serve_option.selected = this.getRestaurantDelivery().isActive ? this.serve_option.list[1] : this.serve_option.list[0]
					this.payment_mode.selected = this.getRestaurantDelivery().isActive ? this.payment_mode.list[1] : {}
        }else{
          this.setRestaurantDeliveryActive(false)
          this.serve_option.selected = this.serve_option.list[0];
        }
			},

      // PAYMENT 
      selectPaymentMode(p_mode=null){
      	this.payment_mode.selected = p_mode == null ? {} : p_mode
      	if(p_mode.id == 'PAY_IMMEDIATELY') {
          setTimeout(() => {
            this.$smoothScroll('PAY_LATER')
          }, 100);
        }
      },
			selectPayment(pm) {
        this.payment_method.selected = pm
				if(!(pm.bank_name == 'DIRECT_PAYMENT' || (pm.bank_name == 'WISE' && pm.payment_method == 'BANK_TRANSFER'))){
					setTimeout(() => {
						this.$smoothScroll('payment_guest_form')
					}, 300);
				}
      },
			paymentMethodDoneLoad(){
        if(this.payment_mode.selected.id == 'PAY_IMMEDIATELY' && !this.getRestaurantDelivery().isActive) this.$smoothScroll('PAY_LATER')
      },

      // SUBMIT DATA
			async validateDelivery(){
        try {
          const { use_delivery, payment_mode, use_biteship } =  this.getMerchant()
          if(!use_delivery) return Promise.resolve();
          
          this.serve_option.error = ''
          this.courierRequiredError = ''
          const { isActive, detail, courier } =  this.getRestaurantDelivery()
          const generalSettingNotValid = (use_delivery && payment_mode != 'PAY_LATER') || !isActive
  
          if(generalSettingNotValid || !isActive) Promise.resolve();
  
          if(this.$isEmpty(detail)){
            this.serve_option.error = 'Please provide your delivery address';
            throw new Error("SERVE");
          }
  
          if(use_biteship && this.$isEmpty(courier)){
            this.courierRequiredError = 'Please select courier'
            throw new Error("COURIER");
          }
          
          return Promise.resolve();
        } catch (error) {
          return Promise.reject(error.message); 
        }
			},
			validatePayment(){
				return new Promise((success,fail)=>{
					this.payment_mode.error = false
					let p_mode = this.getMerchant().payment_mode
					let valid = true
					if(p_mode != 'PAY_LATER'){
						let is_payment_mode_not_selected = p_mode == 'PAY_IMMEDIATELY_OR_LATER' && !this.payment_mode.selected.id
						let is_payment_method = (p_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.selected.id == 'PAY_IMMEDIATELY' ) || p_mode == 'PAY_IMMEDIATELY'

						if(is_payment_mode_not_selected){
							this.payment_mode.error = true
							valid = false
						}else if(is_payment_method){
							this.$refs.payment_method.validateForm().then(()=>valid=true).catch(()=>valid=false)
						}
					}
					setTimeout(()=>{
						if(!valid){
							fail('PAYMENT-SELECTION')
						}else{
							success()
						}
					},100)
				})
			},
	    submitForm(){
	    	return new Promise((success,fail)=>{
	    		this.error_push = ''
					let validateFunc = [
						this.$refs.order_guest_form.validateForm(),
						this.validateDelivery(),
						this.validatePayment()
					]
					if(this.showGuestFormForPayment) validateFunc.push(this.$refs.payment_guest_form.validateForm())
					Promise.all(validateFunc).then(()=>{
	    			const params = this.getParamsInquiry();
						post("CORE_RESTO","v2/tx-inquiry",params,"restaurant_session").then(response=>{
							let res = response.data
							if(res.success){
								this.tx.inquiry = res.data
								if(!this.need_payment){
	              	this.goToPaymentResult()
	              	success()
								}else{
									this.submitPayment()
									.then(()=>success())
									.catch(err=>{
										this.error_push = err
										fail()		
									})
								}
	            }else{
	              this.error_push = res.message
	              fail()
	            }
						})
	    		}).catch(err=>{
						if(err == 'ORDER'){
							this.$smoothScroll('add_menu_section')
						}else if(err === 'SERVE'){
							this.$smoothScroll('top-section')
						}else if(err === 'COURIER'){
							this.$smoothScroll('courier-section')
						}else if(err === 'PAYMENT-SELECTION'){
							this.$smoothScroll('for-payment-section')
						}else if(err === 'PAYMENT'){
							this.$smoothScroll('payment_guest_form')
            }
	    			fail()
	    		})
	    	})
	    },
      getParamsInquiry(){
        let params = {
          merchant_id: this.getMerchant().id,
          customer_detail: {
            name: this.getRestaurantCustomer().name,
            table_number: this.getRestaurantAuth().table_number,
            email: this.getRestaurantCustomer().email,
            phone_number: this.getRestaurantCustomer().phone_number
          },
          products: [],
          notes: this.getRestaurantOrder().notes,
          region: 'Indonesia',
          device: this.$getDeviceType(),
          promo_code: this.getRestaurantOrder().promo_code,
          payment_mode: this.payment_mode.selected.id,
          order_type: this.getMerchant().use_delivery ? this.serve_option.selected.id.toUpperCase() : 'DINE_IN' 
        }

        if(this.serve_option.selected.id == 'delivery'){
          const { destination_position, destination_text, landmark = "-", savedAddress = {} } = this.getRestaurantDelivery().detail;
          
          params.payment_mode = 'PAY_IMMEDIATELY'
          params.delivery_lat = destination_position[0]
          params.delivery_long = destination_position[1]
          params.delivery_landmark = landmark
          params.delivery_text = destination_text
          params.customer_detail.table_number = ''

          if(this.$isNotEmptyV2(savedAddress)){
            const { receiver_name, phone } = savedAddress
            
            if(this.$isNotEmptyV2(receiver_name)) params.delivery_landmark += `. Recipient name : ${receiver_name}`
            if(this.$isNotEmptyV2(phone)) params.delivery_landmark += `. Phone : ${phone}`
          }
          if(this.getMerchant().use_biteship){
            params.delivery_company = "BITESHIP"
            const { courier_code, courier_service_code } = this.getRestaurantDelivery().courier
            params.courier_code = courier_code
            params.courier_service_code = courier_service_code
          }
          
        }else{
          const isPaymentModeMulti = this.getMerchant().payment_mode === 'PAY_IMMEDIATELY_OR_LATER'
          params.payment_mode = isPaymentModeMulti ? this.payment_mode.selected.id : this.getMerchant().payment_mode;
        }
        for(let cart of this.getRestaurantOrder().cart){
          if(cart.variant.length > 0){
            for(const variant of cart.variant){
              const { data: { product_ga_pos_id : id }, qty, notes } = variant  
              params.products.push({id, qty, notes})
            }
          }else{
            const { product: { data: { product_ga_pos_id : id } }, qty, notes} = cart 
            params.products.push({id, qty, notes})
          }
        }
        return params;
      },
	    submitPayment(){
	    	return new Promise((success,fail)=>{
	    		let params = {
	    			merchant_id: this.getMerchant().id,
	    			tx_order_id: this.tx.inquiry.id,
	    			amount: this.total_price,
	    			customer_detail: {
	    				name: this.getRestaurantCustomer().name,
	    				email: this.getRestaurantCustomer().email,
	    				phone_number: this.getRestaurantCustomer().phone_number
	    			},
	    			payment_details:{
	    				id: this.payment_method.selected.id,
			        payment_method: this.payment_method.selected.payment_method,
			        bank_name: this.payment_method.selected.bank_name,
			        payment_channel: this.payment_method.selected.payment_method
	    			}
	    		}

	    		post("CORE_RESTO","v2/tx-payment",params).then(response=>{
	    			let res = response.data
	    			if(res.success){
	    				
							let is_xendit_cc = this.payment_method.selected.bank_name == 'XENDIT' && this.payment_method.selected.payment_method == 'CREDIT_CARD'
							
							if(is_xendit_cc){
                this.tx.payment = res.payment
                this.payment_method.custom_popup = 'XENDIT'
                this.$smoothScroll('restaurant-cart')
	    				}else{
								this.$proceedPayment('RESTAURANT',this.tx.inquiry,res,this.payment_method.selected,'GENERAL')
							}
	    				success()
	    			}else{
	    				fail(res.message)
	    			}
	    		})
	    	})
	    },
	    closeXenditCC(){
        this.tx = {
        	inquiry: {},
        	payment: {}
        }
        this.payment_method.custom_popup = ''
        this.resetAllDataRestaurant()
      },

			serveOptionSelect(serve){
        const isDeliveryButFailed = serve.id === 'delivery' && !this.getRestaurantDeliveryAvb();
        if(!isDeliveryButFailed){
          this.serve_option.selected = serve
          let use_delivery = serve.id == 'delivery'
          this.setRestaurantDeliveryActive(use_delivery)
          if(use_delivery){
            this.payment_mode.selected = this.payment_mode.list[1]
          }else{
            this.payment_mode.selected = {}
          }
        }
        
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/restaurant/Cart.vue